import { useTranslation } from 'react-i18next';

const UNKNOWN_SCREEN_KEY = 'unknown';

export function useUsageLabels() {
  const { t } = useTranslation('assistant');
  return {
    topicLabel: function topicLabel(topic: string): string {
      return t('insights.topicNames.' + topic, { defaultValue: topic });
    },
    screenLabel: function screenLabel(screen: string): string {
      if (screen === UNKNOWN_SCREEN_KEY) {
        return t('insights.screenUnknown');
      }
      return t('destinations.' + screen, { defaultValue: screen });
    },
  };
}
